import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "abs test-account"
}

import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { computed, watch, ref, toRaw, onMounted, onUnmounted, reactive } from 'vue'
import { confirmEdit } from '@/util/useConfirm'
import { searchUrl } from '@/apis/search'
import { useRtfix, isEN, isD2C } from './store'
import { useGlobal } from '@/util/useLoading'
import { callback } from '@/util/useAuthShop'
import { changeLang, langs, t } from '@/plugins/i18n'
import { getIsChoiceShopApi, isAllowedAccess } from '@/apis/user'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import fromPublicApp from '@/util/publicAuth'

// 表格翻译转json
// import ExportModal from '@/components/common/翻译xlsx转json.vue'
import {
  req
  // resetRate
} from '@/util/useYan'
import D2DRedirect from './views/goods/components/D2DRedirect.vue'
import { BuType, initThinkingData, thinkingdata } from './util/buryingPoint'
import { getQueryParams } from './plugins/tripartite-login'
import { UPDATE_TRIPARTITEUSERINFO } from './store/modules/tripartite'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const plat = computed(() => store.state.route.plat)
const buss = reactive(store.state.bussiness)
// const route = useRoute()
watch(() => store.state.route.plat, (val) => {
  if (!val) {
    store.commit('route/plat', 'd2c')
  } else {
    window.localStorage.setItem('systemSource', val !== 'b2b' ? '1' : '2')
  }
}, {
  immediate: true
})

const site = computed(() => store.state.route.site)
const curShop = computed(() => store.state.route.curShop)
const later = ref(1)
const router = useRouter()
const route = useRoute()
initThinkingData()

// adchannel 业务字段冲突导致的
const user: Record<string, any> = {
  channel: route.query.channel,
  channel_group: route.query.channel_group,
  bu_type: BuType.DC,
  nation_code: localStorage.getItem('stationCode'),
  platform_type: 1
}

/** 接收初始化授权信息 */
const initGoogleAuth = () => {
  const third_google = sessionStorage.getItem('third_google') ?? '{}'
  try {
    const json = JSON.parse(third_google);
    if (json.thirdPlatform === 'google') {
      store.commit(UPDATE_TRIPARTITEUSERINFO, json)
    }
    sessionStorage.removeItem('third_google')
  } catch (error) {
    sessionStorage.removeItem('third_google')
  }
}

onMounted(() => {
  try {
    const token = JSON.parse(localStorage.getItem('production_route/token') || '{}').val
    store.dispatch('route/changeToken', token)
  } catch (error) {
  }
  store.dispatch('route/getLineActivity')
  initGoogleAuth()
  const accountId = thinkingdata.persistence.getAccountId()
  console.log(accountId, 'accountId')

  if (!accountId) {
    const { utm_source, utm_medium, utm_campaign, utm_content, channel: nChannel, channel_group } = getQueryParams() || {}
    if (utm_source || nChannel || channel_group || utm_medium || utm_campaign || utm_content) {
      const first_ad_info = {
        utm_source, utm_medium, utm_campaign, utm_content, channel: nChannel, channel_group
      }
      thinkingdata.userSetOnce({ first_ad_info })
    }
  }


})

const account = ref()
// 获取ip地址和用户指纹id，调取接口判断是否允许访问
if (process.env.VUE_APP_ENV === 'prod') {
  fetch('https://ipcost.com/', { headers: { Accept: 'application/json' } }).then(res => res.text()).then(res => {
    var p1 = res?.match(/<small>My IP address V4<\/small>/)?.index
    if (res && p1) {
      var text = res.substring(p1, p1 + 100)
      var regex = /<strong><span class="dr ipv4">(.*?)<\/span><\/strong>/
      var match = regex.exec(text)
      if (match) {
        var ipAddress = match[1]
        FingerprintJS.load().then(fp => fp.get()).then(result => {
          const visitorId = result.visitorId
          console.log(visitorId, 'visitorId')
          isAllowedAccess({ ip: ipAddress, productId: visitorId }).then(res => {
            if (!res.data) {
              store.commit('route/ip', ipAddress)
              store.commit('route/href', window.location.href)
              router.push({ path: '/403' })
            }
          })
        })
      }
    }
  })
}

watch(plat, async (v, old) => {
  later.value++
  // 影响主题色
  document.body.id = v
}, {
  immediate: true
})

watch(curShop, (v) => {
  const token = store.getters.token
  const user = toRaw(store.getters.user)
  console.log(user)
  store.dispatch('extension/transferUser', { token, user, curShop: v })
  later.value++
  console.log('clear Calculator_plugin shop change')
  window.localStorage.removeItem(
    'Calculator_1_plugin'
  )
  window.localStorage.removeItem(
    'Calculator_2_plugin'
  )
  if (v) {
    store.dispatch('route/setChoiceStatus')
  }
})

const handleResize = () => {
  store.commit('observe/resize', Date.now())
}
const handleBeforeUnload = function (e: any) {
  if (store.getters.editing) {
    e.returnValue = 'confirm'
  }
}

let timer: any
onMounted(() => {
  window.addEventListener('resize', handleResize)
  window.addEventListener('beforeload', handleBeforeUnload)
  // console.log(route.query, '上报执行了')
  // thinkingdata.userSetOnce({
  //   ...route.query
  // })
  // resetRate() // app初始化应该去初始化汇率，但是不知道哪里已经初始化过了，这里注释掉
  // 半小时更新一次汇率
  timer = setInterval(() => {
    req()
  }, 1000 * 60 * 30)
})

// 全局监听
onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('beforeload', handleBeforeUnload)
  clearInterval(timer)
})

const token = computed(() => store.getters.token)
// debugger
watch(
  token,
  async (v) => {
    await store.state.route.promise
    const user = toRaw(store.getters.user)
    const curShop = store.getters.curShop
    store.dispatch('extension/transferUser', { token: v, user, curShop })
    if (!v) {
      store.commit('status/editing', false)
    }
  },
  { immediate: true }
)

// 初始请求前台类目保存
store.dispatch('bussiness/once')

router.beforeEach((to, from, next) => {
  confirmEdit(next, () => {
    next(false)
    store.commit('status/renderSidebar', !store.getters.renderSidebar)
  })
})
router.afterEach(() => {
  store.commit('goods/skuImg', '')
})

const apiSearchUrl = useGlobal(searchUrl)
const search = (v: any, num: number) => {
  const detailUrl = decodeURIComponent(v.query.detailUrl.toString())
  // if (isEN() && store.getters.isLogin) {
  //   router.back()
  //   return ElMessage.error('Does not match store name')
  // }
  return apiSearchUrl({ detailUrl, from: 'index' }).then((res) => {
    if (res.success) {
      router.replace(
        useRtfix('goods', { params: { id: res.data.productCode } })
      )
    }
  })
}
watch(route, (v) => {
  buss.schannel = v?.query?.schannel || '2'
  buss.platformType = v?.query?.platformType || ''
  // todo:重定向
  if (v.query?.redirect) {
  }

  // 商品查询
  if (v.query?.detailUrl) {
    search(v, 1)
    return
  }
  // 从公共应用跳转
  if (v.query?.state && v.query.state.toString() in fromPublicApp.APP) {
    fromPublicApp(v.query)
    return
  }
  // 接收店铺授权回调
  callback(route)
})

watch(
  site,
  (v, old) => {
    const title: any = {
      ja: 'THE CKBー中国輸入代行・THE CKBなら丸投げOK!',
      ko: 'THE CKB 중국 수입을 간편하게',
      en: 'THE CKB'
    }
    document.title = title[v]
    const ele: any = document.querySelector('html')
    ele.setAttribute('class', v)
    // 登录时切换国家
    const urlLang = location.href.match(/lang=([^&]+)/i)
    const newLang = urlLang ? urlLang[1] : v
    if (newLang !== localStorage.__lang__ && langs.includes(newLang)) {
      changeLang(urlLang ? urlLang[1] : v)
      location.reload()
      return
    }
    // 针对未登录的情况切换站点
    const siteName = ['ja', 'ko', 'en'].find(
      (i: string) => location.pathname.indexOf(`/${i}/`) > -1
    )
    if (!store.getters.isLogin && siteName) {
      // 未登录状态根据url站点 保存站点信息
      store.commit('route/site', siteName)
      // return
    }
    // if (location.href.indexOf(v) === -1 && store.getters.isLogin) {
    //   console.log('validator2',route.path)
    //   router.replace(route.path)
    // }
  },
  {
    immediate: true
  }
)

// 1

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-system", `app-system-${_unref(plat)}`])
  }, [
    (account.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "当前测试账号:" + _toDisplayString(account.value), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: later.value }))
      ]),
      _: 1
    }, 512), [
      [_directive_loading, _unref(store).state.status.loading]
    ]),
    (_unref(store).state.status.d2dLoading)
      ? (_openBlock(), _createBlock(D2DRedirect, { key: 1 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})